export default __webpack_public_path__ + "static/demolition-pool_removal-1827250002b87d21fe8ea104738349fa.png";